const { REACT_APP_BASE_URL: BASE_API_URL } = process.env;

// for getting all the reply template
export const GET_ALL_REPLY_TEMPLATE = `${BASE_API_URL}/reply_templates/sub_organizations/:subOrgId/templates/`;

// for upate and delete the reply template
export const UPDATE_OR_DELETE_REPLY_TEMPLATE = `${BASE_API_URL}/reply_templates/sub_organizations/:subOrgId/templates/:templateId/`;
